import { BookingState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: BookingState = {
  tab: 0,
  mainTab: 0,
  bookings: [],
  booking: null,
  bookingPrice: null,
  loading: false,
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTab: (state, action: PayloadAction<number>) => {
      state.tab = action.payload;
    },
    // NEW: Add setMainTab reducer
    setMainTab: (state, action: PayloadAction<number>) => {
      state.mainTab = action.payload;

      // Auto-switch logic:
      // When switching to Delivery (mainTab = 1), set tab to 3
      if (action.payload === 1) {
        state.tab = 3;
      }
      // When switching to Limousine (mainTab = 0), default to Transfer if coming from Delivery
      else if (action.payload === 0 && state.tab === 3) {
        state.tab = 0;
      }
      // When switching to Events (mainTab = 2), you can set a default if needed
      // else if (action.payload === 2) {
      //   state.tab = 4; // if you add an events tab value
      // }
    },
    setBooking: (state, action: PayloadAction<any>) => {
      state.booking = action.payload;
    },
    addBooking: (state, action) => {
      state.bookings.unshift(action.payload);
    },
    updateBooking: (state, action) => {
      const booking = action.payload;
      state.booking = booking;
      // state.bookings.every(({ _id }, i) => {
      //   if (booking._id === _id) {
      //     state.bookings[i] = booking;
      //     return false;
      //   }
      //   return true;
      // });
    },
    setBookings: (state, action) => {
      state.bookings = action.payload;
    },
    setBookingPrices: (state, action) => {
      state.bookingPrice = action.payload;
    },
  },
});

const bookingReducer = bookingSlice.reducer;

export const bookingActions = bookingSlice.actions;
export default bookingReducer;
